import { action } from 'typesafe-actions';

import { EventReasonCode, EventReasonPromptContext } from 'types/models/event-reason';
import { EventReasonPromptPreference } from 'types/models/user-preference';

import ActionTypes from './constants';
import { EventReasonsState, PendingEventReasonTagging } from './types';

export const fetchEventReasonCatalog = () =>
  action(ActionTypes.FETCH_EVENT_REASON_CATALOG_REQUEST);

export const fetchEventReasonCatalogSuccess = () =>
  action(ActionTypes.FETCH_EVENT_REASON_CATALOG_SUCCESS);

export const fetchEventReasonCatalogFailure = (message: string) =>
  action(ActionTypes.FETCH_EVENT_REASON_CATALOG_FAILURE, { message }, undefined, true);

export const setEventReasonCatalog = (
  catalogByTriggerType: EventReasonsState['catalogByTriggerType']
) => action(ActionTypes.SET_EVENT_REASON_CATALOG, { catalogByTriggerType });

export const openEventReasonPrompt = (promptContext: EventReasonPromptContext) =>
  action(ActionTypes.OPEN_EVENT_REASON_PROMPT, { promptContext });

export const closeEventReasonPrompt = () =>
  action(ActionTypes.CLOSE_EVENT_REASON_PROMPT);

export const submitEventReasonTagging = (
  reasonCodes: EventReasonCode[],
  freeText: string | null,
  shouldSnooze: boolean
) =>
  action(ActionTypes.SUBMIT_EVENT_REASON_TAGGING, {
    reasonCodes,
    freeText,
    shouldSnooze
  });

export const skipEventReasonTagging = (shouldSnooze: boolean) =>
  action(ActionTypes.SKIP_EVENT_REASON_TAGGING, { shouldSnooze });

export const setPendingEventReasonTagging = (pendingTagging: PendingEventReasonTagging) =>
  action(ActionTypes.SET_PENDING_EVENT_REASON_TAGGING, { pendingTagging });

export const removePendingEventReasonTagging = (id: string) =>
  action(ActionTypes.REMOVE_PENDING_EVENT_REASON_TAGGING, { id });

export const setPendingEventReasonPromptSnooze = (preference: EventReasonPromptPreference) =>
  action(ActionTypes.SET_PENDING_EVENT_REASON_PROMPT_SNOOZE, { preference });

export const removePendingEventReasonPromptSnooze = () =>
  action(ActionTypes.REMOVE_PENDING_EVENT_REASON_PROMPT_SNOOZE);
